export const activityConstants = {
    magicPicure_code: "mp",
    fff_code: "fff",
    scribble_code: "scbl",
    customActivity_code: "customActivity"
  };